export default __webpack_public_path__ + "static/media/change-slide.4b73fdc6.svg";